import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WidgetLoggerService {
  constructor() {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  public logMessage(message: string, data: any) {
    // TODO: NOT FOR PRODUCTION! For Sandbox Debug Purposes only.
  }
}
